/**
 * KV-Keys die System-Cleanup niemals löschen darf.
 * Offline-Registrierung bleibt lokal (Register.jsx → offlineAuthService).
 */

export const REGISTRATION_PROTECTED_KV_KEYS = [
  'offline_businesses',
  'offline_users',
  'currentUser',
  'currentBusiness',
  'managerCode',
  'appLanguage',
  'appCurrency',
  'app_installation_machine_id',
  'app_installation_configured',
  'machine_id_sync_queue',
  'machine_id_column_exists'
];

export function isRegistrationProtectedKey(key) {
  if (!key) return false;
  const k = String(key);
  if (REGISTRATION_PROTECTED_KV_KEYS.includes(k)) return true;
  if (k.startsWith('currentRole_')) return true;
  if (k.startsWith('business_') && k.endsWith('_machine_id')) return true;
  if (k.startsWith('business_') && k.endsWith('_data')) return true;
  return false;
}

export function isCleanupProtectedKey(key) {
  if (isRegistrationProtectedKey(key)) return true;
  if (key.startsWith('Elkheir:v1:meta:')) return true;
  if (key.startsWith('sequences_')) return true;
  if (key.startsWith('worker_sessions_')) return true;
  if (key.startsWith('newCashRegisterData_') || key.startsWith('cashRegisterData_')) return true;
  return false;
}
